import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CircularProgressWithLabel from "./../../components/CirculatProgressWIthLabel";

export default function LeaderboardRow({ title, level, value, count }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        border: "1px solid #2F2F2F",
        padding: "8px 10px 8px 18px",
        borderRadius: 40,
        minHeight: 48,
      }}
    >
      <Stack direction="column">
        <Typography variant="body1">{title}</Typography>
        <Typography variant="body2" color="primary">
          {level}
        </Typography>
      </Stack>
      <Stack>
        <CircularProgressWithLabel value={value} count={count} />
      </Stack>
    </Stack>
  );
}
